<template>
  <div>
    <div class="flex flex-col mb-8">
      <div class="flex items-center text-gray-600">Bestellung</div>
      <div class="flex items-center">
        <span class="mr-2 text-2xl">#{{ order.id }}</span>
        <span>
          <order-status-badge
            v-if="!loading"
            class="text-sm px-2 uppercase"
            :status="order.status"
          ></order-status-badge>
        </span>
      </div>
    </div>

    <div v-if="!loading">
      <div class="mt-10 flex flex-col md:flex-row w-full">
        <div class="w-full md:w-2/3">
          <div class="p-6 shadow mb-6" v-if="order.first_name || order.last_name || order.email">
            <div class="text-xl mb-6">Persönliche Daten</div>

            <div class="font-semibold">{{ order.first_name }} {{ order.last_name }}</div>
            <a
              target="_blank"
              :href="`mailto:${order.email}?subject=localTicketing Bestellung #${order.id}`"
              class="text-gray-800 hover:underline"
              >{{ order.email }}</a
            >
          </div>

          <div class="p-6 shadow">
            <div class="text-xl">{{ count }} Tickets</div>
            <div class="mb-6 text-gray-800">
              Kaufdatum: {{ order.created_at.local | longDate }} Uhr
            </div>

            <div class="pb-2 mt-8 mb-4 flex font-semibold justify-between border-b">
              <div class="w-2/6">Typ</div>

              <div class="w-1/6">Code</div>

              <div class="w-2/6">Block / Reihe / Platz</div>

              <div class="w-1/6 text-right">Preis</div>
            </div>

            <div
              v-for="ticket in order.tickets"
              :key="ticket.id"
              class="py-4 flex justify-between items-center hover:bg-gray-100"
            >
              <div class="w-2/6 truncate">
                <div>{{ ticket.type.title }}</div>
                <div class="text-sm">{{ ticket.type.category.title }}</div>
              </div>
              <div class="w-1/6">{{ ticket.code }}</div>

              <div class="w-2/6">
                {{ ticket.seat_section ? ticket.seat_section : '-' }}
                {{ ticket.seat_section && '/' }} {{ ticket.seat_parent }}
                {{ ticket.seat_parent && '/' }} {{ ticket.seat_own }}
              </div>

              <div class="w-1/6 text-right">{{ ticket.price | price }}</div>
            </div>

            <div class="text-right mt-4 font-semibold">
              Total für {{ count }} Tickets: {{ total | price }}
            </div>
          </div>
        </div>

        <div class="w-full md:w-1/3 md:ml-6 mt-6 md:mt-0">
          <div class="shadow">
            <div class="px-6 py-6 pt-4">
              <router-link
                class="text-xl mt-4 hover:underline"
                :to="{ name: 'events.dashboard', params: { id: order.event.id } }"
                >{{ order.event.title }}</router-link
              >

              <div class="text-gray-800 mt-2">
                {{ order.event.start_date.local | shortDate }} Uhr
              </div>

              <div class="text-gray-800">
                {{ order.event.venue.name }}, {{ order.event.venue.city }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import orderClient from '@/api/central/orders';
import OrderStatusBadge from '@/components/OrderStatusBadge';
import _sumBy from 'lodash/sumBy';
import dayjs from 'dayjs';

export default {
  components: { OrderStatusBadge },
  data() {
    return {
      order: {},
      loading: true,
    };
  },

  filters: {
    shortDate(value) {
      return dayjs(value).format('DD MMM YYYY HH:mm');
    },
    longDate(value) {
      return dayjs(value).format('dddd, DD MMMM YYYY HH:mm');
    },
    price(value) {
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });

      return formatter.format(value / 100);
    },
  },

  computed: {
    total() {
      return _sumBy(this.order.tickets, (ticket) => ticket.price);
    },
    count() {
      return this.order.tickets.length;
    },
  },

  mounted() {
    orderClient.show(this.$route.params.id).then(({ data }) => {
      this.order = data.data;
      this.loading = false;
    });
  },
};
</script>